import { helper } from '@ember/component/helper';

export default helper(function textFiltered(
  [searchTerm, list, ...keys] /*, named*/,
) {
  if (!searchTerm) return list;
  if (!keys || keys.length === 0) return list;
  if (keys.every((key) => !key)) return list;
  if (!list) return [];
  else
    return list.filter((item) => {
      const strings = keys.map((key) => {
        return item?.get?.(key) ?? item[key];
      });

      return strings.some((str) => {
        return str?.toLowerCase?.().indexOf(searchTerm?.toLowerCase?.()) >= 0;
      });
    });
});
